import React, { useEffect, useState } from 'react'
import CartaTokens from '@/../public/images/tokens_sm.png';
import Image from 'next/image';
import { getActionsCost } from '../new-resume/actions';
import { Loader2, Sparkles } from 'lucide-react';

interface IJobDescriptionSection {
  loading: boolean,
  jd: string,
  setJd: React.Dispatch<React.SetStateAction<string>>,
  handleGenerate: () => Promise<void>,
}

function JobDescriptionSection({ loading, jd, setJd, handleGenerate }: IJobDescriptionSection) {
  const [ genQCost, setGenQCost ] = useState<number>(0);
  const [ isLoadingCost, setIsLoadingCost ] = useState<boolean>(true);

  useEffect(() => {
    async function getActions () {
      setIsLoadingCost(true);

      let a = await getActionsCost('INTERQ01');
      console.log(a.data);
      setGenQCost(a.data);
      setIsLoadingCost(false);
    }

    getActions();

  }, []);

  return (
    <>
      <label className='text-indigo-600 ml-3 font-medium'>Job Description</label>
      {/* Left Side: Input */}
      <div className="flex flex-col space-y-4">
        <textarea
          className="w-full h-96 p-4 bg-gray-50 rounded-xl border-none outline-none
                    shadow-[inset_4px_4px_8px_rgba(0,0,0,0.1),inset_-4px_-4px_8px_rgba(255,255,255,1)]
                    focus:ring-2 focus:ring-blue-400 transition-all"
          placeholder="Paste the job requirements here..."
          value={jd}
          onChange={(e) => setJd(e.target.value)}
        />
        <button
          onClick={handleGenerate}
          disabled={loading || !jd}
          className="w-full py-3 bg-indigo-600 text-white rounded-lg font-bold hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
        >
          {
            loading ? 'Analyzing JD...' 
            : (
                <div className="flex justify-center items-center gap-2">
                  <div className="flex justify-center items-center">
                    <Sparkles className="mr-2 w-4 h-4" /> 
                    Generate Questions
                  </div>
                  <div className="ml-2 flex justify-center items-center text-sm">
                    <span>{"("}</span><Image src={CartaTokens} width={20} height={20} alt="Carta AI Tokens" />
                    <span className="ml-1">
                      {
                        isLoadingCost 
                        ? <Loader2 size={32} className="animate-spin" /> 
                        : genQCost
                      } 
                      <span > tokens</span>
                    </span><span>{")"}</span> {/* className="hidden md:inline" */}
                  </div>
                </div>
              )
          }
        </button>
      </div>
    </>
  )
}

export default JobDescriptionSection